//REDUCER
const loggedReducer = (state = "ffffffffffffffffff", action) => {
    switch (action.type) {
      case 'isLog':
        if(state === "")
          return false;
        else
          return true;

       case 'getEmail':
         return state 
         
       case 'setEmail':
       {
          state =  action.payload;
          return action.payload; 
       }

      default:
       return state;
  
    }
};

export default loggedReducer;